<ng-container *transloco="let t; prefix: 'group-management.panels.remove-from-trip'">
  @if (participants().length > 0) {
    <app-panel-body>
      <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-content-container>
            <div class="space-y-4">
              @if (isBulk()) {
                <p>{{ t('confirm-bulk', { count: participants().length }) }}</p>
                <ul class="list-disc space-y-1 pl-5 text-secondary-text">
                  @for (person of participants(); track person.id) {
                    <li>{{ person.firstname }} {{ person.lastname }} ({{ person.email }})</li>
                  }
                </ul>
                @if (unlinkedMinors().length > 0) {
                  <div class="space-y-2">
                    <p>{{ t('unlinked-minors-intro') }}</p>
                    <ul class="list-disc space-y-1 pl-5 text-secondary-text">
                      @for (minor of unlinkedMinors(); track minor.id) {
                        <li>{{ minor.firstname }} {{ minor.lastname }}</li>
                      }
                    </ul>
                  </div>
                }
              } @else {
                @if (copyVariant() === 'non-roster') {
                  <p>{{ t('confirm-non-roster') }}</p>
                } @else {
                  <p>{{ t('confirm') }}</p>
                }
                <p class="text-center">
                  <strong>{{ participants()[0].firstname }} {{ participants()[0].lastname }}</strong><br />
                  {{ participants()[0].email }}
                </p>
              }
              @if (unlinkedMinors().length > 0) {
                <div class="space-y-2">
                  <p>{{ t('unlinked-minors-intro') }}</p>
                  <ul class="list-disc space-y-1 pl-5 text-secondary-text">
                    @for (minor of unlinkedMinors(); track minor.id) {
                      <li>{{ minor.firstname }} {{ minor.lastname }}</li>
                    }
                  </ul>
                </div>
              }
              @if (showFundraisingWarning()) {
                <p class="text-secondary-text"><em>{{ t('fundraising-warning') }}</em></p>
              }
            </div>
          </app-content-container>
        </div>
        <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
          <button
            type="button"
            class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
            (click)="cancel()"
            [disabled]="submitting()"
          >
            {{ t('cancel') }}
          </button>
          <button
            type="button"
            class="rounded-md bg-danger px-4 py-2 text-sm font-semibold text-white hover:bg-danger-600 disabled:opacity-50"
            (click)="confirm()"
            [disabled]="submitting()"
          >
            {{ t('remove') }}
          </button>
        </div>
      </div>
    </app-panel-body>
  }
</ng-container>
